import { render } from "./InputArea.vue?vue&type=template&id=5691114b"
import script from "./InputArea.vue?vue&type=script&lang=js"
export * from "./InputArea.vue?vue&type=script&lang=js"

import exportComponent from "D:\\inspemblelcsgn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__